import { createDefaultLoadable, ILoadableWrapper, arrayToILoadableWrapperArray } from "../../models";
import { IDevice } from "../../models/device.interface";
import { ILoadableArray } from "../../models/loadable";

export const DEVICES_KEY: string = "devices"

export interface ICachable {
    timestamp: Date | null
}

export interface IDeviceState {
    keepers: ILoadableArray<ILoadableWrapper<IDevice>> & ICachable,
}

export const initialDeviceState: IDeviceState = {
    keepers: {
        ...createDefaultLoadable(),
        items: arrayToILoadableWrapperArray(JSON.parse(sessionStorage.getItem(DEVICES_KEY) ?? "[]")),
        timestamp: null,
    },
}

export function getInitialDeviceState(): IDeviceState {
    return initialDeviceState;
}
